var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress, styled, Switch, Typography } from '@mui/material';
import { useHearingAidSimulator } from 'hx-hearing-aid-simulator';
import { objectWithoutProperties } from 'hx-util';
import { useLottie } from 'lottie-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import animationData from '@/assets/animations/headphones-sound-waves-animation.json';
export function HearingAidSimulator() {
    var volume = useSelector(function (state) { return state.wizard.form.volume; });
    var _a = useHearingAidSimulator({
        autoPlay: true,
        volume: volume / 100,
    }), state = _a.state, toggleHearingAid = _a.toggleHearingAid, stop = _a.stop;
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (!document.hidden)
                return;
            stop();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "grid gap-8 place-items-center" }, { children: [_jsxs("div", __assign({ className: "flex flex-1" }, { children: [_jsxs(Typography, __assign({ className: "text-right text-dark-text" }, { children: ["Hearing aid", _jsx("br", {}), " ", _jsx("strong", { children: "OFF" })] })), _jsx(Switch, { checked: state.hearingAidOn, onChange: toggleHearingAid }), _jsxs(Typography, __assign({ className: "text-left text-dark-text" }, { children: ["Hearing aid", _jsx("br", {}), " ", _jsx("strong", { children: "ON" })] }))] })), state.isInitializing ? (_jsx(CircularProgress, {})) : (_jsx(Animation, { animationData: animationData, loop: true, paused: !state.isPlaying }))] })) }));
}
var Animation = styled(function (props) {
    var lottieOptions = objectWithoutProperties(props, [
        'paused',
    ]);
    var _a = useLottie(lottieOptions), View = _a.View, setSpeed = _a.setSpeed, play = _a.play, stop = _a.stop;
    useEffect(function () {
        if (props.paused) {
            stop();
        }
        else {
            play();
        }
    }, [props.paused]);
    useEffect(function () {
        setSpeed(0.6);
    });
    return View;
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '150px',
            aspectRatio: '1',
            marginInline: 'auto'
        },
        _b[theme.breakpoints.up('md')] = {
            width: '150px',
        },
        _b['& svg > g > g > g:not(:last-child) > g > path'] = {
            fill: theme.palette.primary.main,
        },
        _b['& svg > g > g > g:last-child > g > path'] = {
            fill: '#A9A9A8',
        },
        _b);
});
